import '../styles/site-logo.scss'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import { cmsDataService } from '@/common/services/cms.data.service'

export const SiteLogo: FC = () => {
    const logoUrl = cmsDataService.get()?.header?.siteLogo?.image?.url

    return (
        <Link className="site-logo" to="/">
            <img className="v-image" src={logoUrl} alt="Curzon" />
        </Link>
    )
}
